import React, { useState } from "react";
import "./CartSummary.css";
import GradientButton from "../../../../../components/button/Button";
import StripeCheckoutModal from "./StripeCheckoutModal";
import { useCart } from "../../../../../context/CartContext";

interface CartSummaryProps {
  subTotal: number;
  tax: number;
  total: number;
}

const CartSummary: React.FC<CartSummaryProps> = ({ subTotal, tax, total }) => {
  const [showModal, setShowModal] = useState(false);
  const { cart } = useCart();

  // Extract only product_id and quantity
  const line_items = cart.map((item: any) => ({
    product_id: item.id, // Assuming `id` is product ID
    quantity: item.quantity,
  }));

  return (
    <div className="retail-checkout-cart-summary">
      <h2>Cart Summary</h2>
      <div className="retail-checkout-row">
        <span>Sub Total</span>
        <span>${subTotal.toFixed(2)}</span>
      </div>
      <div className="retail-checkout-row">
        <span>Tax</span>
        <span>${tax.toFixed(2)}</span>
      </div>
      <div className="retail-checkout-divider" />
      <div className="retail-checkout-row retail-checkout-total">
        <span>Total</span>
        <span>${total.toFixed(2)}</span>
      </div>

      <GradientButton
        text="Checkout"
        onClick={() => setShowModal(true)}
        disabled={cart.length === 0}
        bgColor={cart.length === 0 ? "#e0e0e0" : undefined}
        textColor={cart.length === 0 ? "#888" : undefined}
      />
      {showModal && (
        <StripeCheckoutModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          line_items={line_items}
        />
      )}
    </div>
  );
};

export default CartSummary;
